module.exports = __webpack_public_path__ + "img/logo_dark.257b1498.webp";